import { Link } from "react-router-dom";
import DropdownUser from "./DropdownUser";
import miniLogo from "../../../assest/mini_logo.png";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <header
  className="sticky top-0 z-999 flex w-full"
  style={{
    background:
      "radial-gradient(120% 60% at 100% 0%, rgba(249,115,22,0.09) 0%, rgba(249,115,22,0) 55%), linear-gradient(180deg, #FFF9F2 0%, #FFFFFF 22%)",
    boxShadow: "0 2px 16px rgba(0,0,0,0.04)",
    borderBottom: "1px solid #F1E4D3",
  }}
>
  <div
    className="flex flex-grow items-center justify-between gap-3 px-3 sm:px-4 md:px-6 2xl:px-11"
    style={{ height: "71px" }}
  >
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden flex-shrink-0">
          {/* <!-- Hamburger Toggle BTN --> */}
          <button
            aria-controls="sidebar"
            onClick={(e) => {
              e.stopPropagation();
              setSidebarOpen(!sidebarOpen);
            }}
            className="z-99999 block rounded-lg border border-orange-100 bg-white p-1.5 shadow-[0_2px_10px_rgba(0,0,0,0.04)] lg:hidden flex-shrink-0"
          >
            <span className="relative block h-[1.375rem] w-[1.375rem] cursor-pointer">
              <span className="du-block absolute right-0 h-full w-full">
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-orange-500 delay-[0] duration-200 ease-in-out ${
                    !sidebarOpen && "!w-full delay-300"
                  }`}
                ></span>
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-orange-500 delay-150 duration-200 ease-in-out ${
                    !sidebarOpen && "delay-400 !w-full"
                  }`}
                ></span>
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-orange-500 delay-200 duration-200 ease-in-out ${
                    !sidebarOpen && "!w-full delay-500"
                  }`}
                ></span>
              </span>
              <span className="absolute right-0 h-full w-full rotate-45">
                <span
                  className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-orange-500 delay-300 duration-200 ease-in-out ${
                    !sidebarOpen && "!h-0 !delay-[0]"
                  }`}
                ></span>
                <span
                  className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-orange-500 duration-200 ease-in-out ${
                    !sidebarOpen && "!h-0 !delay-200"
                  }`}
                ></span>
              </span>
            </span>
          </button>
          {/* <!-- Hamburger Toggle BTN --> */}

          <Link className="block flex-shrink-0 lg:hidden" to="/">
            <img
              width={40}
              src={miniLogo}
              alt="miniLogo"
              className="drop-shadow-sm w-9 sm:w-11"
            />
          </Link>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 2xsm:gap-7 min-w-0 justify-end flex-shrink-0 ml-auto">
  <DropdownUser />
</div>
      </div>
    </header>
  );
};

export default Header;